<template lang="pug">
	.cart
		.cart-preloader(v-show="loading")

		header.cart-header
			h1.cart-header__title {{ $t('pages.cart.title') }}

		template(v-if="products != null && products != undefined && Object.entries(products).length")
			section.cart-content
				.cart-list
					.cart-product(v-for="(product, index) in products" :key="index")
						.cart-product__row
							.cart-product__col.cart-product__image
								nuxt-link(:to="localePath({ name: 'product-slug', params: { slug: product.slug } })  + '/'")
									img.lazyload(src="/img/img-preloader.svg" 
																:data-src="product.image" 
																:alt="product.product_title"
																:title="product.product_title")

							.cart-product__col.cart-product__info
								h3.title
									nuxt-link(:to="localePath({ name: 'product-slug', params: { slug: product.slug } }) + '/'"
														v-html="product.product_title")

								//- Tablet & mobile version
								.cart-product__info-adaptive(v-if="$mq === 'mobileSmall' || $mq === 'mobile' || $mq === 'tablet'")
									.cart-product__price
										.price-total(v-html="currencySymbol(product.line_subtotal)")
									.cart-product__quantity
										a.quantity-decrease(href="#" @click.prevent="decreaseQuantity(product.key, (product.quantity - 1))")
											svg-icon.icon-minus(name="minus")
										.quantity-count {{ product.quantity }}
										a.quantity-increase(href="#" @click.prevent="increaseQuantity(product.key, (product.quantity + 1))")
											svg-icon.icon-plus(name="plus")

								.sizes
									.sizes__title {{ $t('pages.cart.product.size') }}
									.sizes__option {{ product.variation.attribute_pa_sizes.split('-')[0] }}
								.remove-product
									a.remove-product__link(href="#" @click.prevent="removeProduct(product.key)") {{ $t('pages.cart.product.remove') }}

							.cart-product__col.cart-product__quantity(v-if="$mq === 'laptop' || $mq === 'desktop'")
								a.quantity-decrease(href="#" @click.prevent="decreaseQuantity(product.key, (product.quantity - 1))")
									svg-icon.icon-minus(name="minus")
								.quantity-count {{ product.quantity }}
								a.quantity-increase(href="#" @click.prevent="increaseQuantity(product.key, (product.quantity + 1))")
									svg-icon.icon-plus(name="plus")

							.cart-product__col.cart-product__price(v-if="$mq === 'laptop' || $mq === 'desktop'")
								.price-total(v-html="currencySymbol(product.line_subtotal)")

					footer.cart-footer
						.cart-footer__order
							h3.total(v-html="currencySymbol(totals.total)")
							.content
								nuxt-link.btn.checkout(:to="localePath('checkout') + '/'") {{ $t('links.checkout') }}
								.info
									p {{ $t('pages.cart.info') }}

				.cart-info
					.cart-info-item(v-for="(item, index) in info")
						h3.cart-info-item__title {{ item.title }}
						.cart-info-item__icons(v-if="item.has_icons")
							img.lazyload(src="/img/img-preloader.svg"
														data-src="/img/master_visa_fondy-1.png" 
														alt="Payments"
														title="Payments")
							//- i.icon.icon--visa
								svg-icon.icon-visa(name="visa")
							//- i.icon.icon--mastercard
								svg-icon.icon-mastercard(name="mastercard")
						.cart-info-item__descr(v-else)
							p {{ item.descr }}

			//- footer.cart-footer(v-if="$mq === 'tablet' || $mq === 'laptop' || $mq === 'desktop'")
			//-   .cart-footer__order
			//-     h3.total(v-html="currencySymbol(totals.total)")
			//-     .content
			//-       nuxt-link.btn.checkout(:to="localePath('checkout')") {{ $t('links.checkout') }}
			//-       .info
			//-         p {{ $t('pages.cart.info') }}

		.cart-empty(v-else)
			h2.cart-empty__title {{ $t('pages.cart.empty.title') }}
			.cart-empty__descr
				p {{ $t('pages.cart.empty.descr') }}
			nuxt-link.btn.cart-empty__btn(:to="localePath('catalog') + '/'") {{ $t('links.allShoes') }}
</template>

<script>
import { mapState } from 'vuex'
import api from '@/api/index'

export default {
  layout: 'no-sidebar',

  data() {
    return {
      loading: false
    }
  },

  computed: {
    ...mapState({
      cart: state => state.cart,
      products: state => state.cart.products,
      totals: state => state.cart.totals,
      info: state => state.content.data.cart_content
    })
  },

  beforeMount() {
    this.loadCartData()
  },

  head() {
    return {
      title: this.$t('meta.cart.title'),
      titleTemplate: null,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('meta.cart.description')
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.$t('meta.cart.title')
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.$t('meta.cart.description')
        },
        { hid: 'robots', name: 'robots', content: 'noindex,nofollow' }
      ]
    }
  },

  methods: {

    async loadCartData() {
      const currency = this.$cookies.get('currency')

      await this.$store.dispatch('cart/GET_PRODUCTS', { currency })
      await this.$store.dispatch('cart/GET_TOTALS', { currency })
    },

    async removeProduct(key) {
      const currency = this.$cookies.get('currency')

      this.loading = true

      await this.$store.dispatch('cart/REMOVE_PRODUCT', { key })
      await this.$store.dispatch('cart/GET_TOTALS', { currency })

      this.loading = false
    },

    async increaseQuantity(key, quantity) {
      const currency = this.$cookies.get('currency')

      this.loading = true

      await this.$store.dispatch('cart/UPDATE_PRODUCT', { key, quantity })
      await this.$store.dispatch('cart/GET_TOTALS', { currency })

      this.loading = false
    },

    async decreaseQuantity(key, quantity) {
      const currency = this.$cookies.get('currency')

      this.loading = true

      await this.$store.dispatch('cart/UPDATE_PRODUCT', { key, quantity })
      await this.$store.dispatch('cart/GET_TOTALS', { currency })

      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/helpers/vars';
@import '~assets/scss/helpers/mixins';

.cart {
  position: relative;
  padding: 25px 0 65px;
	min-height: calc(100vh - 414px);

  @include tablet {
    padding-bottom: 50px;
  }

  @include mobile {
    padding: 30px 0 20px;
  }
}

.cart-preloader {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $whiteColor;
  background-image: url('/img/preloader.svg');
  background-position: center;
  background-size: cover;
}

.cart-header {
  &__title {
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 2px;
    text-transform: uppercase;

    @include mobile {
      font-size: 16px;
      line-height: 1.45;
    }
  }
}

.cart-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 25px;

  @include mobile {
    margin-top: 30px;
  }
}

.cart-list {
  flex: 0 0 100%;
  max-width: 805px;

  @include laptop {
    max-width: calc(100% - 320px);
  }

  @include mobile {
    max-width: 100%;
  }
}

.cart-info {
  flex: 0 0 100%;
  max-width: 300px;
  padding-top: 10px;

  @include mobile {
    max-width: 100%;
  }
}

.cart-info-item {
  margin-bottom: 30px;

  @include mobile {
    margin-bottom: 20px;
  }

  &__title {
    margin-bottom: 5px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  &__icons {
    display: flex;
    align-items: center;

    .icon {
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__descr {
    color: rgba($blackColor, 0.7);
  }
}

.cart-product {
  margin-bottom: 30px;

  @include mobile {
    margin-bottom: 20px;
  }

  &__row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }

  &__col {
    padding: 10px 0;
  }

  &__image {
    flex: 0 0 100%;
    max-width: 180px;
    padding: 0;
    margin-right: 20px;

    @include tablet {
      margin: 0 auto;
    }

    @include mobile {
      max-width: 145px;
      padding: 50px 0;
      margin-bottom: 10px;
    }

    a {
      display: block;
    }
  }

  &__info {
    flex: 0 0 100%;
    max-width: 360px;
    margin-right: 35px;

    @include laptop {
      max-width: 30%;
    }

    @include tablet {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      max-width: 100%;
      padding: 0;
    }

    &-adaptive {
      flex: 0 0 100%;
      max-width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }

    .title {
      margin-bottom: 30px;
      font-size: 20px;
      font-weight: 500;
      line-height: 1.4;

      @include tablet {
        flex: 0 0 100%;
        max-width: 100%;
        margin-bottom: 10px;
      }

      @include mobile {
        font-size: 18px;
      }
    }

    .sizes {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      font-size: 12px;
      font-weight: 500;
      line-height: 1;
      text-transform: uppercase;

      @include tablet {
        margin-bottom: 0;
      }

      @include mobile {
        font-size: 10px;
      }

      &__option {
        margin-left: 5px;
      }
    }

    .remove-product {
      &__link {
        border-bottom: 1px solid $blackColor;
        transition: border-color 0.3s;

        @include mobile {
          font-size: 12px;
        }

        &:hover {
          border-color: transparent;
        }
      }
    }
  }

  &__quantity {
    flex: 0 0 100%;
    max-width: 80px;
    display: flex;
    align-items: center;
    margin-right: 10px;
    margin-left: auto;
    font-size: 22px;
    line-height: 1.25;

    @include tablet {
      justify-content: flex-end;
      max-width: 50%;
      margin: 0;
      font-size: 18px;
    }

    .quantity-decrease,
    .quantity-increase {
      flex: 0 0 100%;
      max-width: 20px;
      height: 20px;

      display: flex;
      justify-content: center;
      align-items: center;
    }

    .quantity-count {
      display: block;
      margin: 0 5px;
    }
  }

  &__price {
    text-align: right;

    @include tablet {
      margin-left: 0;
      text-align: left;
    }

    .price-total {
      font-size: 18px;
      letter-spacing: 0.75px;

      @include mobile {
        font-size: 16px;
      }
    }
  }
}

.cart-footer {
  margin-top: 50px;
  width: 100%;

  @include mobile {
    flex: 0 0 100%;
    max-width: 100%;
    margin-top: 30px;
    margin-bottom: 50px;
  }

  &__order {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;

    @include mobile {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .total {
      padding-top: 15px;
      font-size: 24px;
      font-weight: 500;
      letter-spacing: 0.86px;

      @include mobile {
        padding-top: 0;
        margin-bottom: 10px;
      }
    }

    .content {
      flex: 0 0 100%;
      max-width: 300px;
      margin-left: 20px;
      text-align: center;

      @include mobile {
        margin: 0;
      }
    }

    .btn {
      font-weight: 500;

      @include mobile {
        padding: 12px 20px;
      }
    }

    .info {
      margin-top: 10px;
      color: $greyColor;
      font-size: 12px;

      @include mobile {
        margin-top: 5px;
      }
    }
  }
}

.cart-empty {
  width: 50%;
  margin: 80px auto 25px;
  text-align: center;

  &__title {
    margin-bottom: 25px;
    font-size: 36px;
    font-weight: 500;
    line-height: 1.2;
  }

  &__descr {
    margin-bottom: 30px;
    font-size: 20px;
    line-height: 1.3;
  }

  &__btn {
    margin: 0 auto;
    max-width: 300px;
    font-weight: 500;
    text-transform: uppercase;
  }
}
</style>
